import api from '../api/ad';
var $$model = require('assets/util/model.js');

var _ = window._;

var model = new $$model({});

var $$assert = require('assets/util/assert.js');
var tool = require('assets/util/tool.js');

var searchObj = tool.getUrlSearch();

_.extend(model, {
    getAdData: (cityId, adposId, callbackFn) => {
        var _this = this;
        $$assert(cityId, 'n');
        $$assert(adposId, 'n');
        var data = {
            adposId: adposId,
            cityId: cityId
        };

        if (searchObj.bedate && searchObj.bedate != '') {
            data.date = searchObj.bedate;
        }
        api.getAdData(data).then(res => {
            var i;
            if (+res.code === 200) {
                for (var item in res.data.ad_map) {
                    if (res.data.ad_map.hasOwnProperty(item)) {
                        var curAd = res.data.ad_map[ item ];
                        if (curAd.pv_link) {
                            for (i = 0; i < curAd.pv_link.length; i++) {
                                curAd.pv_link[ i ] = encodeURIComponent(curAd.pv_link[ i ]);
                            }
                        }
                        if (curAd.click_link) {
                            for (i = 0; i < curAd.click_link.length; i++) {
                                curAd.click_link[ i ] = encodeURIComponent(curAd.click_link[ i ]);
                            }
                        }
                    }
                }
            }
            callbackFn(res)
        }, res => callbackFn(res))
    },
    getAdDataLs: (cityId, adposId, cookie, callbackFn) => {
        var _this = this;
        $$assert(cityId, 'n');
        $$assert(adposId, 'n');
        $$assert(cookie, 'n');
        var data = {
            adposId: adposId,
            cityId: cityId,
            cookieId: cookie
        };
        if (searchObj.bedate && searchObj.bedate != '') {
            data.date = searchObj.bedate;
        }

        api.getAdData(data).then(res => {
            var i;
            if (+res.code === 200) {
                for (var item in res.data.ad_map) {
                    if (res.data.ad_map.hasOwnProperty(item)) {
                        var curAd = res.data.ad_map[ item ];
                        if (curAd.pv_link) {
                            for (i = 0; i < curAd.pv_link.length; i++) {
                                curAd.pv_link[ i ] = encodeURIComponent(curAd.pv_link[ i ]);
                            }
                        }
                        if (curAd.click_link) {
                            for (i = 0; i < curAd.click_link.length; i++) {
                                curAd.click_link[ i ] = encodeURIComponent(curAd.click_link[ i ]);
                            }
                        }
                    }
                }
            }
            callbackFn(res)
        }, res => callbackFn(res))
    },
    getAdDataByPage: function(cityId, pageIndex){
        var _this = this;
        var data = {
            cityId: cityId,
            pageIndex: pageIndex
        };
        return api.getAdDataByPage(data);
    }
});
module.exports = model;



// WEBPACK FOOTER //
// ./src/model/service/advert.js